export const getTypeContrat = (title: string) => {
  return /scolaire/i.test(title)
    ? 'scolaire'
    : /retraite/i.test(title)
    ? 'retraite'
    : /rc vie privée/i.test(title)
    ? 'rcvp'
    : /(Assistance MAPFRE)|(Assurance Voyage)/i.test(title)
    ? 'voyage'
    : /(Assurance Obsèques à Dago)|(RIP)/i.test(title)
    ? 'rapatriement'
    : /vehicule/i.test(title)
    ? 'auto'
    : 'noType';
};
